import { safeDocumentReferrer, safeLocationHostname, safeUrlHostname } from "./safeglobals";

export default class Referrer {

    public static get() : Array<string> {
        
        const referrer = Referrer.getRaw();

        // make sure to return an empty set if the referrer
        // is an empty string
        if (referrer.length === 0) {
            return [];
        }

        // handle samesite referrer. safeLocationHostname() can return '' when
        // location has been stubbed; skip the check then, rather than treating
        // every referrer as same-site.
        const pageHost = safeLocationHostname().toLowerCase();
        if (pageHost.length > 0 && Referrer.isSameSite(referrer, pageHost)) {
            return [];
        }

        // remove query parameters from the referrer
        // to avoid very large strings
        if (referrer.indexOf('?') !== -1) {
            return [referrer.substring(0, referrer.indexOf('?'))];
        }
        return [referrer];
    }

    /**
     * Same-site means the referrer's host is the page's host or a subdomain of it,
     * on a label boundary (3.0.0, BACKLOG.md §9.13 row 5). The old test, "the
     * referrer URL contains the page host anywhere", called notexample.com and
     * example.org/links/example.com same-site and dropped them as referrals.
     *
     * Where the referrer cannot be parsed (no URL constructor, or a malformed
     * value) the old containment test still applies, so those browsers behave
     * exactly as before.
     */
    public static isSameSite(referrer: string, pageHost: string) : boolean {
        const host = safeUrlHostname(referrer).toLowerCase();
        if (host.length === 0) {
            return referrer.toLowerCase().indexOf(pageHost) !== -1;
        }
        if (host === pageHost) {
            return true;
        }
        const suffix = '.' + pageHost;
        return host.length > suffix.length && host.substring(host.length - suffix.length) === suffix;
    }

    public static getRaw() : string {
        if (window.__mock_referrer) {
            return window.__mock_referrer;
        }
        return safeDocumentReferrer();
    }

}